import React, { useCallback, useEffect, useState } from "react";
import {
    Box,
    FormControlLabel,
    Grid,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
    MenuItem,
    Divider,
    Autocomplete,
    Checkbox,
    Button,
    Tooltip,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import MedicineDoses, { MedicineDose } from "../../../../OPD/add-patient-record/MedicineDoses";
import axios from "axios";
import debounce from "lodash.debounce";
import CustomAutocomplete from "../../../../autocomplete-field";
import PreTemplateModal from "./PreTemplateModal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import RulesRegulationModal from "./Rules&Regulation";

interface PreOperationProps {
    onChange: (data: any) => void;
    data: FormData;
    otherTabsData: any;
    profile: any;
}

interface FormData {
    procedure_type: any;
    incision: string;
    procedure_Notes: string;
    operative_Findings: string;
    drain: boolean;
    specimen: boolean;
    condition_At_End_Of_Surgery: string;
    handed_Over_By: string;  // New field
    handed_Over_To: string;  // New field
    lab_Name: string;       // New field
    lab_No: string;         // New field
    reporting: string;     // New field
    time_Out: Object; // New field
}
const PreOperation: React.FC<PreOperationProps> = ({ onChange, data, otherTabsData, profile }) => {
    const [opnTemp, setOpnTemp] = useState<boolean>(false);
    const [temp, setTemp] = useState<any[]>([])
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [doctors, setDoctors] = useState<any[]>([]);
    const [searchDoc, setSearchDoc] = useState<string>("");
    const [procedure, setProcedure] = useState<any[]>([])
    const [selectedProcedure, setSelectedProcedure] = useState<any>()
    const [formData, setFormData] = useState<any>({
        surgeon_Name: profile?.data?.fullName,
        assistant_Name: {},
        OTA: {},
        anaesthetist: {},
        procedure_type: {},
        incision: '',
        procedure_Notes: '',
        operative_Findings: '',
        drain: false,
        condition_At_End_Of_Surgery: 'Stable',
        specimen: false,
        lab_Name: '',
        lab_No: '',
        handed_Over_By: '',
        handed_Over_To: '',
        reporting: '',
        time_Out: {
            confirm_All_Team_Members_Have_Introduced_Themselves_By_Name: true,
            surgeon_Reviews: true,
            anaesthesia_Team_Review: true,
            nursing_Team_Reviews: true,
            Has_Antibiotic_Prophylaxis_Been_Given_within_the_Last_60_Minutes: 'yes',
            is_Essential_Imaging_Displayed: 'yes'
        },
    });
    const [isMultiline, setIsMultiline] = useState(false);
    const handleBlur = () => setIsMultiline(false);
    const handleFocus = () => setIsMultiline(true);
    const [AnaesthetistOptions, setAnaesthetistOptions] = React.useState<any[]>([]);
    const [OTOptions, setOTOptions] = React.useState<any[]>([]);
    const [isMultilinetwo, setIsMultilinetwo] = useState(false);
    const handleBlurtwo = () => setIsMultilinetwo(false);
    const handleFocustwo = () => setIsMultilinetwo(true);
    const [signColor, setSignColor] = useState<boolean>(false)

    const getOT = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/users/getAllUserByCategoryName?categoryName=OT Incharge`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
            if (response?.data?.isSuccess === true) {
                setOTOptions(response?.data?.data)
            }
        } catch (err) {
            console.error('Error fetching anesthetist:', err);
        }
    }
    const getAnaesthetist = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/users/getAllUserByCategoryName?categoryName=Anaesthetist`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
            if (response?.data?.isSuccess === true) {
                setAnaesthetistOptions(response?.data?.data)
            }
        } catch (err) {
            console.error('Error fetching anesthetist:', err);
        }
    }
    useEffect(() => {
        getAnaesthetist()
        getOT();
    }, [])
    const handleAnaesthetistChange = async (value: any) => {
        if (value !== formData?.anaesthetist) {
            const newUpdatedFormData = {
                ...formData,
                anaesthetist: value || null
            };
            setFormData(newUpdatedFormData);
        }
    };
    const handleOTChange = async (value: any) => {
        if (value !== formData?.OTA) {
            const newUpdatedFormData = {
                ...formData,
                OTA: value || null
            };

            setFormData(newUpdatedFormData);
        }
    };
    const fetchDoctors = async (search: any) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/getAssignedDoctores?count=50000&search=${search}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            const fetchedDoc = response.data?.data || [];
            const uniqueDoc = Array.from(
                new Map(fetchedDoc?.map((item: any) => [item?.fullName, item]))?.values()
            );
            setDoctors(uniqueDoc);
        } catch (error) {
            console.error(error);
        }
    };
    const debouncedFetchDoctor = useCallback(debounce(fetchDoctors, 500), []);
    useEffect(() => {
        debouncedFetchDoctor(searchDoc);
    }, [searchDoc, debouncedFetchDoctor]);

    const handleDoctorChange = (value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            assistant_Name: value,
        }));
    };

    const handleOpenClose = () => {
        setIsOpen(!isOpen)
    }

    const handleTimeOutUpdate = (updatedTimeOut: any) => {
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            time_Out: updatedTimeOut,
        }));
    };

    useEffect(() => {
        onChange(formData);

    }, [formData]);

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setFormData((prevData: any) => ({
            ...prevData,
            [name as keyof FormData]: value,
        }));
    };
    const handleCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { name, checked } = e.target;
        setFormData((prevData: any) => ({
            ...prevData,
            [name as keyof FormData]: checked,
        }));
    };

    useEffect(() => {
        if (data) {
            setFormData(data);
        }
        if (data?.procedure_type) {
            setSelectedProcedure(data?.procedure_type || {})
        }
        const timeoutId = setTimeout(() => {
            if (data?.time_Out) {
                handleTimeOutUpdate(data?.time_Out);
            }
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [data]);

    const getOpTemplate = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_IPD_API_URL}/ipd-operation-template/getAllTemplates?ope_type=per`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            setTemp(response.data?.data || [])
        } catch (error) {
        }
    }
    const getProcedures = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_IPD_API_URL}/ipd-procedure/getAllBySearch`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            setProcedure(response.data?.data || [])
        } catch (error) {
        }
    }

    useEffect(() => {
        getOpTemplate()
        getProcedures()
    }, [])
    const handleSelectChangeTemplate = (e: any, value?: string) => {
        const selectedTemplate = e.target.value;
        setFormData((prevData: any) => ({
            ...prevData,
            operative_Findings: selectedTemplate[0]?.templateData?.operativeFindings,
            procedure_Notes: selectedTemplate[0]?.templateData?.procedureNotes,
            incision: selectedTemplate[0]?.templateData?.incision
        }));
    };
    const handleSelectChangeProcedure = (newValue: any) => {
        const selectedProcedure = newValue;
        setSelectedProcedure(selectedProcedure);

        // Update formData with separate procedureId and procedureName
        if (newValue) {
            setFormData((prevData: any) => ({
                ...prevData,
                procedureId: newValue._id,
                procedureName: newValue.procedureName,
                procedure_type: newValue // Keep the full object as well if needed
            }));
        } else {
            setFormData((prevData: any) => ({
                ...prevData,
                procedureId: null,
                procedureName: null,
                procedure_type: null
            }));
        }
    };
    useEffect(() => {
        setFormData((prevData: any) => ({
            ...prevData,
            procedure_type: selectedProcedure
        }));
    }, [selectedProcedure])
    const handleAddButtonClickTemplate = () => {
        setOpnTemp(true)
    }
    const handleCloseDialog = () => {
        setOpnTemp(false);
        getOpTemplate()
    };
    const handleDateChange = (newValue: any) => {
        const updatedDate = newValue ? newValue.toISOString() : '';
        setFormData((prevData: any) => ({
            ...prevData,
            reporting: updatedDate,
        }));
    };

    return (
        <Box >
            <Grid container>
                <Grid item md={4} sm={4} xs={8}>
                    <CustomAutocomplete
                        multiple
                        options={temp || []}
                        onChange={(event, newValue) => {
                            handleSelectChangeTemplate({
                                target: {
                                    value: newValue.map((diag: any) => diag),
                                },
                            });
                        }}
                        getOptionLabel={(option) => option?.templateName
                        }
                        filterOptions={(options, { inputValue }) =>
                            options.filter((option: any) =>
                                option?.templateName
                                    ?.toLowerCase()
                                    .includes(inputValue.toLowerCase(),)
                            )
                        }
                        placeholder="Template"
                        handleAddClick={handleAddButtonClickTemplate}
                    />
                </Grid>
                <Grid item md={8} sm={8} xs={4}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button size='small' variant='contained' sx={{
                            // background: formData?.time_Out && Object?.values(formData?.time_Out)?.some(value => value === true) ? '#009E65' : '#FFBF00',
                            background: signColor ? "#009E65" : "#FFBF00",
                            "&:hover": {
                                background: formData?.time_Out && Object?.values(formData?.time_Out)?.some(value => value === true) ? '#009E65' : '#FFBF00',
                            },
                        }} onClick={handleOpenClose}>
                            Time Out
                        </Button>
                    </Box>
                </Grid>

            </Grid>
            {/* <Typography variant="h5" gutterBottom sx={{fontSize:'12px', fontWeight:'bold', mt:0.4}}>Per-Operation Template</Typography> */}
            <Grid container spacing={1} sx={{ mt: 1.4 }}>
                <Grid item md={2} sm={3} xs={6}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Incision :
                    </Typography>
                    <TextField
                        name="incision"
                        value={formData?.incision}
                        onChange={handleInputChange}
                        className="search-field"
                        size="small"
                        placeholder="Enter Incision"
                        fullWidth
                    />
                </Grid>
                <Grid item md={1} sm={2} xs={6}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Drain :
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={formData?.drain || false}
                                onChange={handleCheckboxChange}
                                name="drain"
                            />
                        }
                        label="Yes"
                    />
                </Grid>
                <Grid item md={3} sm={4} xs={6}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Condition At End Of Surgery :
                    </Typography>
                    <RadioGroup
                        name="condition_At_End_Of_Surgery"
                        row
                        value={formData?.condition_At_End_Of_Surgery}
                        onChange={handleInputChange}
                    >
                        <FormControlLabel value="Unstable" control={<Radio size="small" />} label={<span style={{ fontSize: '10px' }}>Unstable</span>} />
                        <FormControlLabel value="Stable" control={<Radio size="small" />} label={<span style={{ fontSize: '10px' }}>Stable</span>} />
                    </RadioGroup>
                </Grid>
                <Tooltip title="Note: Add options from IPD → Settings → Templates → Procedures." placement="top" arrow>
                    <Grid item md={2} sm={3} xs={6}>
                        <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                            Procedure Done :
                        </Typography>

                        <CustomAutocomplete
                            options={procedure || []}
                            onChange={(event, newValue) => {
                                handleSelectChangeProcedure(newValue);
                            }}
                            getOptionLabel={(option) => option?.procedureName || ''}
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option: any) =>
                                    option?.procedureName
                                        ?.toLowerCase()
                                        .includes(inputValue.toLowerCase(),)
                                )
                            }
                            placeholder="Procedure"
                            value={selectedProcedure}
                        />
                    </Grid>
                </Tooltip>
                <Grid item md={2} sm={3} xs={6}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Doctor Name :
                    </Typography>
                    <TextField
                        value={formData?.surgeon_Name}
                        className="search-field"
                        size="small"
                        disabled
                        fullWidth
                    />
                </Grid>
                <Grid item md={2} sm={3} xs={6}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Ass. Doctor Name :
                    </Typography>
                    <Autocomplete
                        size="small"
                        fullWidth
                        options={doctors?.filter((doc) => doc?.fullName !== formData?.surgeon_Name) || []}
                        getOptionLabel={(option) => option?.fullName || ""}
                        onChange={(event, value) => handleDoctorChange(value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Ass.Doctor Name"
                                variant="outlined"
                                fullWidth
                                className="search-field"
                                onChange={(e) => setSearchDoc(e.target.value)}
                            />
                        )}
                        value={formData?.assistant_Name || null}
                    />
                </Grid>
                <Grid item md={3} sm={3} xs={6}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#3F3F3F", }}>Anaesthetist:</Typography>
                    <CustomAutocomplete
                        options={AnaesthetistOptions}
                        value={formData?.anaesthetist || null}
                        onChange={(event, newValue) => handleAnaesthetistChange(newValue)}
                        getOptionLabel={(option) => option?.fullName || ""}
                        filterOptions={(options, { inputValue }) =>
                            options.filter((option: any) =>
                                option?.fullName?.toLowerCase().includes(inputValue.toLowerCase())
                            )
                        }
                        placeholder="Select Anaesthetist"
                    />
                </Grid>
                <Grid item md={3} sm={3} xs={6}>
                    <Typography sx={{ fontSize: "12px", fontWeight: "600", color: "#3F3F3F", }}>OTA:</Typography>
                    <CustomAutocomplete
                        options={OTOptions}
                        value={formData?.OTA || null}
                        onChange={(event, newValue) => handleOTChange(newValue)}
                        getOptionLabel={(option) => option?.fullName || ""}
                        filterOptions={(options, { inputValue }) =>
                            options.filter((option: any) =>
                                option?.fullName?.toLowerCase().includes(inputValue.toLowerCase())
                            )
                        }
                        placeholder="Select OTA"
                    />
                </Grid>
                <Grid item md={3} sm={3} xs={12}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Procedure Note :
                    </Typography>
                    <TextField
                        name="procedure_Notes"
                        value={formData?.procedure_Notes}
                        onChange={handleInputChange}
                        size="small"
                        fullWidth
                        InputProps={{
                            style: {
                                borderRadius: "12px",
                                background: "#F5F5FB",
                                fontSize: "12px",
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "none",
                                },
                                "&:hover fieldset": {
                                    border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "none",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                top: "-2px",
                            },
                        }}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        multiline={isMultiline}
                        minRows={isMultiline ? 3 : 1}
                        placeholder="Enter Procedure Note"
                    />
                </Grid>
                <Grid item md={3} sm={3} xs={12}>
                    <Typography sx={{ fontSize: "12px", color: "#3F3F3F", fontWeight: "600" }}>
                        Operative Findings :
                    </Typography>
                    <TextField
                        name="operative_Findings"
                        value={formData?.operative_Findings}
                        onChange={handleInputChange}
                        size="small"
                        fullWidth
                        InputProps={{
                            style: {
                                borderRadius: "12px",
                                background: "#F5F5FB",
                                fontSize: "12px",
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "none",
                                },
                                "&:hover fieldset": {
                                    border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "none",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                top: "-2px",
                            },
                        }}
                        onFocus={handleFocustwo}
                        onBlur={handleBlurtwo}
                        multiline={isMultilinetwo}
                        minRows={isMultilinetwo ? 3 : 1}
                        placeholder="Operative Findings"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item md={3} sm={4} xs={6}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={formData?.specimen || false}
                                onChange={handleCheckboxChange}
                                name="specimen"
                            />
                        }
                        label={<span style={{ fontSize: '12px' }}>Specimen Sent Lab</span>}
                    />
                </Grid>
                {formData.specimen && (
                    <Grid container spacing={1}>
                        <Grid item md={3} sm={4} xs={6}>
                            <TextField
                                name="handed_Over_By"
                                value={formData?.handed_Over_By}
                                onChange={handleInputChange}
                                className="search-field"
                                size="small"
                                label="Handed Over By"
                                fullWidth
                            />
                        </Grid>

                        <Grid item md={3} sm={4} xs={6}>
                            <TextField
                                name="handed_Over_To"
                                value={formData?.handed_Over_To}
                                onChange={handleInputChange}
                                className="search-field"
                                size="small"
                                label="Handed Over To"
                                fullWidth
                            />
                        </Grid>

                        <Grid item md={3} sm={4} xs={6}>

                            <TextField
                                name="lab_Name"
                                value={formData?.lab_Name}
                                onChange={handleInputChange}
                                className="search-field"
                                size="small"
                                label="Lab Name"
                                fullWidth
                            />
                        </Grid>

                        <Grid item md={3} sm={4} xs={6}>

                            <TextField
                                name="lab_No"
                                value={formData?.lab_No}
                                onChange={handleInputChange}
                                className="search-field"
                                size="small"
                                label="Lab No"
                                fullWidth
                            />
                        </Grid>

                        <Grid item md={3} sm={4} xs={6}>
                            {/* <Typography sx={{ fontSize: "14px", color: "#3F3F3F", fontWeight: "600" }}>
                                Reporting Date:
                            </Typography> */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label='Reporting Date'
                                    name="reporting"
                                    value={formData?.reporting ? dayjs(formData?.reporting) : null}  // Ensure dayjs object
                                    onChange={handleDateChange}
                                    format="DD.MM.YYYY"
                                    sx={{
                                        "& fieldset": {
                                            border: "none",
                                        },
                                        "& .MuiInputBase-root": {
                                            height: "38px",
                                            fontSize: "12px",
                                            overflow: "hidden",
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            border: "none",
                                            backgroundColor: "#F5F5FB",
                                        },
                                        "& .MuiCalendarPicker-root": {
                                            overflow: "hidden",
                                        },
                                        "& .css-4jnixx-MuiStack-root": {
                                            paddingTop: "0px",
                                        },
                                        width: "100%",
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <PreTemplateModal handleCloseDialog={handleCloseDialog} opnTemp={opnTemp} />
            <RulesRegulationModal isOpen={isOpen} handleOpenClose={handleOpenClose} setSignColor={setSignColor} onTimeOutUpdate={handleTimeOutUpdate} initialFormState={formData?.time_Out} />

        </Box>
    );
};

export default PreOperation;







